<template>
  <div>
    <DialogBase v-model="inputedValue.dialog" :title="title" :width="width">
      <v-container class="pa-8 baseStyle">
        <v-row>
          <v-col>
            {{ noName + $t('product.product_number') + ':' + noValue }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span class="yCenter">
              <span class="mr-5">
                {{ dateName + $t('product.product_days') }}日
              </span>
              <NormalDatePicker
                v-model="inputedValue.data.date"
                width="135px"
              />
            </span>
          </v-col>
        </v-row>
        <v-row class="mt-12">
          <v-col cols="12">
            <NormalButton
              :text="buttonName"
              textSize="16px"
              height="50px"
              width="100%"
              @click="onClick"
            />
          </v-col>
        </v-row>
      </v-container>
    </DialogBase>
  </div>
</template>
<script>
import DialogBase from './DialogBase'

import { NormalButton } from '@/components/items'
import NormalDatePicker from '@/components/items/inputs/NormalDatePicker'
import { commonUtil } from '@/util'

export default {
  components: {
    DialogBase,
    NormalButton,
    NormalDatePicker
  },
  props: {
    value: {
      type: Object,
      require: true,
      default: () => ({})
    },
    width: { default: '470px' },
    title: { default: '' },
    noName: { default: '' },
    dateName: { default: '' },
    buttonName: { default: 'order.order_complete' },

    noValue: { default: '' }
  },
  data: () => ({
    displayFlg: false
  }),
  created() {
    this.inputedValue.data.date = commonUtil.getToday()
  },
  methods: {
    onClick() {
      this.$emit('complete')
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.baseStyle {
  font-size: 14px;
}
#original-expansion-panel::v-deep .v-expansion-panel::before {
  box-shadow: none;
}
</style>
